import React from "react";
import { Box, useColorModeValue } from "@chakra-ui/react";

const Bar = ({ children }) => {
  const bgColor = useColorModeValue("blue.600", "brand.main");
  const textColor = useColorModeValue("white", "white");
  
  return (
    <Box bg={bgColor} py={2} px={4} overflowX="auto" whiteSpace="nowrap">
        <Box color={textColor} textAlign="left" fontSize="sm" display="flex" alignItems="center">
        {children}
        </Box>
    </Box>
  );
};

export default Bar;
